import type { ChartWrapperProps } from "components/charts";
import { reportingColors } from "features/Library/Common/utils/constants";
import { chartColorScale, emailReportColorScale } from "features/Library/Common/utils/performanceUtils";

const FILES_SYNCED_WRAPPER_PROPS: ChartWrapperProps = {
  titles: ["Average Files Synced Activity"],
  showLegend: true,
  includeOrg: true,
  legendLabels: ["Synced"],
  colorRange: [reportingColors.blue],
};

const GOAL_CHART_PROPS_MAP: Record<string, ChartWrapperProps> = {
  "Teams Meetings": {
    titles: ["Average Meeting Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Attended", "Organized"],
    colorRange: chartColorScale,
  },
  "Teams Messages": {
    titles: ["Average Message Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Posts", "Chats", "Replies"],
    colorRange: emailReportColorScale,
  },
  "Teams Calls": {
    titles: ["Average Call Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Calls"],
    colorRange: [reportingColors.blue],
  },
  "OneDrive Files Viewed": {
    titles: ["Average Files Viewed Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Viewed or Edited"],
    colorRange: [reportingColors.blue],
  },
  "OneDrive Files Shared": {
    titles: ["Average Files Shared Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Internal", "External"],
    colorRange: chartColorScale,
  },
  "OneDrive Files Synced": FILES_SYNCED_WRAPPER_PROPS,
  "SharePoint Files Synced": FILES_SYNCED_WRAPPER_PROPS,
  "SharePoint Files Viewed": {
    titles: ["Average Files Viewed Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Viewed or Edited"],
    colorRange: [reportingColors.blue],
  },
  "SharePoint Page Visits": {
    titles: ["Average Page Visits Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Visits"],
    colorRange: [reportingColors.blue],
  },
  "SharePoint Shared Files": {
    titles: ["Average Shared Files Activity"],
    showLegend: true,
    includeOrg: true,
    legendLabels: ["Internal", "External"],
    colorRange: chartColorScale,
  },
} as const;

export const getGoalChartProps = (key: string): ChartWrapperProps => {
  return GOAL_CHART_PROPS_MAP[key] ?? { titles: ["Unknown Goal"] };
};
